import { API_BASE_URL_ENV } from "../../jsx/common/common";
import BaseService from "../BaseService";
import http from "../HttpService";

const apiEndpoint = API_BASE_URL_ENV() + "/requests/vacation-cancellation";

export default class CancellationService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	changeStatus(id, params) {
		return http.patch(`${apiEndpoint}/${id}/status`, { ...params });
	}
}
